import * as React from 'react';
import { Col, Image } from 'react-bootstrap';
import mimoMonitorsLogo from '../../../assets/images/mimo-monitors-logo.png';

const MimoLogo = () => {
    return (
        <div className='logo-container'> 
            <Image src={mimoMonitorsLogo} alt='Mimo Monitors Logo'></Image>
            {/* <Image src="https://i.ibb.co/VW7W41f/collapsed-mimo-logo.png" alt='Mimo Monitors Logo'></Image> */}
        </div>
    );
}

export default MimoLogo;
